import type { ReactNode } from "react";

export function ModelBadge({
  icon,
  label,
}: {
  icon: ReactNode;
  label: string;
}) {
  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-lumen-50 px-2 py-0.5 text-[10px] font-semibold text-lumen-800 dark:bg-lumen-900/30 dark:text-lumen-200">
      {icon}
      {label}
    </span>
  );
}
